import { render, staticRenderFns } from "./OrderServiceCreateUpdate.vue?vue&type=template&id=f0ee4fd2&"
import script from "./OrderServiceCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./OrderServiceCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports